import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { ResultMatchAOComponent } from '../AOMatched'
import { DisplayStatusComponent } from './utils'
import { useToast } from "../../../toastHook";

export const AOReadMatchResultComponent = () => {

    const { display } = useToast();
    const { key } = useParams();
    const [aoParsed, setAoParsed] = useState();
    const [matchResult, setMatchResult] = useState();
    const [resultStatus, setResultStatut] = useState();
    const [configuration, setConfiguration] = useState();
    const [feedbackKey, setFeedbackKey] = useState('')

    useEffect(() => {
        if (!key) {
            return;
        }

        axios.get('/api/aoreadondemand/readao?key=' + key).then(response => {
            if (response.data) {
                setAoParsed(response.data);
            }
        })

        axios.get('/api/aoreadondemand/matchedresult?key=' + key).then(response => {
            if (response.data) {
                setMatchResult(response.data);
            }
        })

        axios.get('/api/aoreadondemand/status?key=' + key).then(response => {
            setResultStatut(response.data)
        });

        axios.get('/api/aoreadondemand/config?key=' + key).then(response => {
            setConfiguration(response.data)
        });

    }, [key]);

    if (!key) {
        return <></>
    }

    const getDetail = index => {
        return axios.get('/api/aoreadondemand/explain?key=' + key + '&row=' + index)
    }

    const setFeedbackWithKey = (key, feedback, onSuccess) => {
        axios.post("/api/feedback/setwithkey?key=" + key, { feedbackScore: feedback.feedbackScore, feedbackMessage: feedback.feedbackMessage, personalInfoId: feedback.personalInfoId })
            .then(response => {
                if (response.status === 200) {
                    display({
                        titre: 'feedback enregistré',
                        text: `feedback enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'success'
                    });

                    onSuccess();
                }
                else {
                    display({
                        titre: 'feedback non entregistré',
                        text: `feedback non enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'danger'
                    });
                }
            });
    }

    const setFeedback = (feedback, onSuccess) => {

        if (!aoParsed.value) {
            return;
        }

        if (feedbackKey) {
            setFeedbackWithKey(feedbackKey, feedback, onSuccess);
        }
        else {
            axios.post("/api/feedback/getkey", { appelOffre: aoParsed.value, results: matchResult.map(x => { return { personalInfoId: x.personalInfoId, score: x.score, additionalInfo: x.additionalInfo } }) })
                .then(response => {
                    if (response.status === 200 && response.data) {
                        setFeedbackKey(response.data);

                        setFeedbackWithKey(response.data, feedback, onSuccess);
                    }
                    else {
                        display({
                            titre: 'feedback non entregistré',
                            text: `feedback non enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                            severity: 'danger'
                        });
                    }
                })
        }
    }

    var aoResult = <></>
    if (aoParsed && matchResult && resultStatus) {
        aoResult = <><ResultMatchAOComponent canExplain={resultStatus.canExplain} matchingResults={matchResult} aoParsed={aoParsed} getDetail={getDetail} onlyIntercontrats={configuration?.onlyIntercontrats} setFeedback={ setFeedback } /></>
    }


    return <div><DisplayStatusComponent calculKey={key} checkStatus={status => status.isParsed} errorMessageCheckStatus={"L'appel d'offre n'a pas pu être parsé"} /> {aoResult} </div>

}





